// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./TabListTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabList-module__Container__qx5mt {
    display: flex;
    gap: var(--ds-xs);
}

.TabList-module__Horizontal__Bf34G {
    overflow-x: auto;
}

.TabList-module__Default__ugPR3 {
    padding: var(--ds-xs);
    border: var(--ds-border-width) solid var(--ds-tab-list-border-color);
    border-radius: var(--ds-border-radius-sm);
    backdrop-filter: blur(var(--ds-blur));
}
/* Padding keeps the focus outline inside the scroll box (margin cancels it); a background line spans the scrolled width. */
.TabList-module__Ghost__u1Eps {
    margin-block: calc(-1 * var(--ds-border-width-focus));
    padding: var(--ds-border-width-focus) var(--ds-xs);
    background: linear-gradient(
            var(--ds-tab-list-border-color),
            var(--ds-tab-list-border-color)
        )
        left bottom
        calc(var(--ds-border-width) + var(--ds-border-width-focus)) / 100%
        var(--ds-border-width) no-repeat;
}

.TabList-module__Vertical__Pqnwm {
    flex-direction: column;
}

.TabList-module__FullWidth__xxacx {
    width: 100%;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `TabList-module__Container__qx5mt`,
	"Horizontal": `TabList-module__Horizontal__Bf34G`,
	"Default": `TabList-module__Default__ugPR3`,
	"Ghost": `TabList-module__Ghost__u1Eps`,
	"Vertical": `TabList-module__Vertical__Pqnwm`,
	"FullWidth": `TabList-module__FullWidth__xxacx`
};
export default ___CSS_LOADER_EXPORT___;
